<template>
  <div>
    <el-table ref="auditTable" :data="auditList" height="900" :row-class-name="withdrawListRowClassName"
      @selection-change="handleSelectionChange">
      <el-table-column v-if="activeTab == '1'" type="selection" width="55">
      </el-table-column>
      <el-table-column label="用户ID" fixed>
        <template slot-scope="scope">
          <a :class="scope.row.mark ? 'red' : 'account-link'" @click="getUserDetail(scope.row.userId, scope.row.email)">
            {{ scope.row.userId }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="realName" label="姓名"> </el-table-column>
      <el-table-column prop="id" label="订单号" width="120"> </el-table-column>
      <el-table-column prop="txFee" label="手续费"> </el-table-column>
      <el-table-column prop="minerFee" label="矿工费">
        <template slot-scope="scope">
          {{ scope.row.minerFee }}
        </template>
      </el-table-column>
      <el-table-column prop="actualAmount" label="实际到账"> </el-table-column>
      <!-- </el-table-column> -->
      <!-- <el-table-column prop="minerFeeCoin" label="矿工费币种" width="100"> </el-table-column> -->
      <el-table-column min-width="60" label="时间" width="100">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column width="120" label="是否异常账号" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="txCoin" label="币种"> </el-table-column>
      <el-table-column prop="chain" label="币种链"> </el-table-column>
      <el-table-column prop="txAmount" label="提现数量"> </el-table-column>
      <el-table-column label="提现地址" min-width="150">
        <template slot-scope="scope">
          <a :href="scope.row.txNetworkLink" target="_blank" class="network-link">
            {{ scope.row.txToWallet }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="hash" width="220">
        <template slot-scope="scope">
          <a :href="scope.row.txHash" target="_blank" class="network-link">
            {{ scope.row.txHash }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="txStatus" label="状态" width="240">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color" v-if="scope.row.status !== 2">
            {{ scope.row.__status.text }}
          </el-tag>
          <span v-if="scope.row.status === 2" class="text-disabled">
            {{ scope.row__status.text }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="txType" label="提现类型">
        <template slot-scope="scope">
          <span v-if="scope.row.txType === -1">提现</span>
          <span v-else-if="scope.row.txType === -2">内部转出</span>
        </template>
      </el-table-column>
      <el-table-column prop="txStatusInner" label="内部状态" width="200">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.txStatusInner == 'FAIL_CANNOT_RETRY'">失败不能重试</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'EXECUTING_WITHDRAW'">正在执行中</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'FAIL'">失败</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'HOT_NOT_ENOUGH_MONEY'">热钱包余额不足</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'VALIDATE_ARGUMENT_FAIL'">加密校验不通过</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'INIT'">初始化，可以进行转账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'REPEAT'">重试</el-tag>
          <el-tag type="success" v-else-if="scope.row.txStatusInner == 'SUCCESS'">成功</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'DUPLICATE_TO_ADDRESS'">重复提现目标地址</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'NOT_EXISTED_TO_ADDRESS'">目标地址错误或者不存在</el-tag>
          <el-tag type="warning" v-else-if="
            scope.row.txStatusInner == 'TRANSACTION_HASH_RETURN_NULL'
          ">返回Tx hash值为空</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'SIGN_ERROR'">Sign失败</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'SUBMIT_ERROR'">Submit失败</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'VERIFY_ERROR'">Verify失败</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'EXECUTING_DISPOSE'">正在执行中</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'REPEAT_CANNOT_RETRY'">重复不能重试</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'BALANCE_NOT_ENOUGH'">变更余额不足</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'WAITING_FOR_CONFIRMATION'">等待确认中</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'UNSUPPORTED_TRANSACTION'">不支持此交易</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" show-overflow-tooltip label="备注">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="280" align="center">
        <template slot-scope="scope">
          <el-tooltip content="重试" v-if="
            ((scope.row.txStatus === 4 &&
              retryableStatus.includes(scope.row.txStatusInner)) ||
              scope.row.txStatus === 5) &&
            canRetry(scope.row.txStatus)
          ">
            <el-button size="mini" circle icon="el-icon-refresh" @click="retryWithdrawal(scope.row)">
            </el-button>
          </el-tooltip>
          <!-- <el-tooltip
            content="重试"
            v-if="
              (scope.row.txStatus === 4 &&
                retryableStatus.includes(scope.row.txStatusInner)) ||
                (scope.row.txCoin === 'EOS' && scope.row.txStatus === 5)
            "
          >
            <el-button
              size="mini"
              circle
              icon="el-icon-refresh"
              @click="retryWithdrawal(scope.row)"
            >
            </el-button>
          </el-tooltip> -->
          <el-tooltip content="开始审核" v-if="
            scope.row.txStatus === 1 &&
            $hasPerm('tenant:audit_withdrawal:tab_1_start_review')
          ">
            <el-button type="primary" size="mini" @click="startWithdrawReview(scope.row)">
              开始审核
            </el-button>
          </el-tooltip>
          <el-tooltip content="置为异常" v-if="scope.row.txStatus === 4 && canMarkAbnormal(scope.row.txStatus)">
            <el-button type="danger" @click="freezeAudit(scope.row)" size="mini" icon="el-icon-warning" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="撤销" v-if="
            scope.row.txStatus === 6 &&
            $hasPerm('tenant:audit_withdrawal:tab_6_cancel')
          ">
            <el-button @click="cancelAudit(scope.row)" size="mini" circle icon="el-icon-back">
            </el-button>
          </el-tooltip>
          <el-tooltip content="发起提现" v-if="
            scope.row.txStatus === 4 &&
            $hasPerm('tenant:audit_withdrawal:tab_4_send_withdrawal')
          ">
            <el-button @click="showSendDialog(scope.row.id)" size="mini" type="success" icon="el-icon-check" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="手动转账确认成功" v-if="
            scope.row.txStatus === 5 &&
            $hasPerm('tenant:audit_withdrawal:tab_5_manual_confirm')
          ">
            <el-button type="success" @click="handleManualConfirm(scope.row.id)" icon="el-icon-success" size="mini"
              circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="退回未审核" v-if="
            scope.row.txStatus === 5 &&
            userInfo.roleId === 1 &&
            $hasPerm('tenant:audit_withdrawal:tab_5_return_to_not_approved')
          ">
            <el-button @click="handleReturnToNotApproved(scope.row.id, scope.row.email)" icon="el-icon-back" size="mini"
              circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="置为区块已发送" v-if="
            scope.row.txStatus === 4 &&
            $hasPerm('tenant:audit_withdrawal:tab_4_mark_sent')
          ">
            <el-button @click="handleSentConfirmed(scope.row)" icon="el-icon-s-promotion" size="mini" circle>
            </el-button>
          </el-tooltip>
          <el-button v-if="showApprovalRecordButton" type="primary" plain size="mini"
            @click="openApprovalRecordDialog(scope.row)">
            审批记录
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrap" style="text-align: right; margin: 10px 0px">
      <pagination :size="pagination.size" :page="pagination.page" :total="audistCount"
        @pageChanged="handleCurrentChange">
      </pagination>
    </div>
    <div class="user-withdrawal-records-wrap">
      <el-dialog :visible.sync="showUserDialog" title="账户余额信息" width="1200px">
        <withdraw-records v-if="showUserDialog" :uid="nowUserId" :emails="emails"></withdraw-records>
      </el-dialog>
    </div>
    <div class="send-trans-dialog">
      <el-dialog :visible.sync="ifShowSendDialog" @close="closeSendDialog" width="800px">
        <el-form :model="sendTransForm" ref="sendTransForm" label-width="100px">
          <el-form-item prop="transId" label="网络ID" :rules="[{ required: true, message: '请输入网路ID' }]">
            <el-input v-model="sendTransForm.transId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="sendTransNow()">确定提交</el-button>
            <el-button @click="closeSendDialog()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <!-- 谷歌验证 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="备注信息">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 重试区块dialog -->
    <el-dialog :title="title1" :visible.sync="retryDialogVisible" width="25%" :before-close="handleClose">
      <el-form ref="retryForm" :model="retryForm" :rules="rules" label-width="120px">
        <el-form-item label="gasPrice" prop="gasPrice">
          <el-input v-model="retryForm.gasPrice"></el-input>
        </el-form-item>
        <el-form-item label="gasLimit" prop="gasLimit">
          <el-input v-model="retryForm.gasLimit"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="retryDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="retrySubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 置为区块dialog -->
    <el-dialog title="置为区块发送验证" :visible.sync="blockDialogVisible" width="25%" :before-close="handleClose">
      <el-form ref="blockForm" :model="blockForm" :rules="rules" label-width="120px">
        <el-form-item label="txHash" prop="txHash">
          <el-input v-model="blockForm.txHash"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blockDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="blockSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="谷歌验证" :visible.sync="googleReviewVisible" width="400px" append-to-body
      :before-close="handleGoogleReviewBeforeClose">
      <el-form ref="googleReviewForm" :model="googleReviewForm" :rules="googleReviewRules" label-width="100px">
        <el-form-item label="谷歌验证码" prop="googleCode">
          <el-input v-model="googleReviewForm.googleCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeGoogleReviewDialog">取 消</el-button>
        <el-button type="primary" @click="confirmGoogleReview">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="reviewDialogVisible" width="920px" append-to-body :before-close="handleClose"
      @closed="onReviewDialogClosed">
      <template slot="title">
        <span>提现审批</span>
        <span v-if="reviewRow.userId" class="review-title-sub">（用户ID：{{ reviewRow.userId }}）</span>
      </template>
      <div v-if="reviewRow.mark" class="review-risk-banner">异常账号</div>
      <el-form ref="reviewFormRef" :model="reviewForm" :rules="reviewRules" label-width="100px">
        <el-form-item label="审批意见" prop="remark">
          <el-input type="textarea" :rows="4" v-model="reviewForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="审批结果" prop="decision">
          <el-select v-model="reviewForm.decision" @change="onReviewDecisionChange" style="width: 100%">
            <el-option label="审批通过" value="APPROVE"></el-option>
            <el-option label="审批拒绝" value="REJECT"></el-option>
            <el-option label="置为异常" value="ABNORMAL"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充提记录">
          <div v-loading="reviewTxSummaryLoading" class="review-dw-panel">
            <el-row :gutter="16" type="flex" align="middle">
              <el-col :span="7">
                <div class="review-dw-stat-label">总充值（折合 USDT）</div>
                <div class="review-dw-stat-value">
                  {{ formatReviewUsdt(reviewTxSummary.totalDepositUsdt) }}
                </div>
              </el-col>
              <el-col :span="7">
                <div class="review-dw-stat-label">总提现（折合 USDT）</div>
                <div class="review-dw-stat-value">
                  {{ formatReviewUsdt(reviewTxSummary.totalWithdrawUsdt) }}
                </div>
              </el-col>
              <el-col :span="10">
                <el-date-picker v-model="reviewTxTimeRange" type="datetimerange" range-separator="至"
                  start-placeholder="开始时间" end-placeholder="结束时间" value-format="timestamp" style="width: 100%"
                  @change="onReviewTxTimeRangeChange" />
              </el-col>
            </el-row>
            <div class="review-dw-expand-row">
              <el-button type="text" :icon="reviewTxDetailExpanded ? 'el-icon-minus' : 'el-icon-plus'
                " @click="toggleReviewTxDetail" />
            </div>
            <div v-show="reviewTxDetailExpanded" class="review-dw-detail">
              <el-table v-loading="reviewTxDetailLoading" :data="reviewTxDetailList" size="small" border
                max-height="280">
                <el-table-column prop="txTypeName" label="类型" width="72" />
                <el-table-column prop="txCoin" label="币种" width="88" />
                <el-table-column prop="txAmount" label="数量" min-width="100" />
                <el-table-column label="时间" min-width="152">
                  <template slot-scope="scope">{{
                    scope.row.createdTime | moment }}</template>
                </el-table-column>
                <el-table-column prop="id" label="订单号" min-width="120" show-overflow-tooltip />
              </el-table>
              <el-pagination small layout="prev, pager, next" :page-size="reviewTxDetailSize"
                :current-page="reviewTxDetailPage" :total="reviewTxDetailTotal"
                @current-change="onReviewTxDetailPageChange" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="审批记录">
          <el-table :data="approvalTimeline" size="small" border max-height="280">
            <el-table-column prop="operatorDisplayName" label="审批人" min-width="120">
            </el-table-column>
            <el-table-column prop="approvalStatusName" label="审批状态" min-width="120">
            </el-table-column>
            <el-table-column label="审批时间" min-width="160">
              <template slot-scope="scope">{{
                scope.row.updateTime | moment
              }}</template>
            </el-table-column>
            <el-table-column prop="remark" label="审批意见" min-width="160" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviewDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmWithdrawReviewSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="approvalRecordVisible" width="920px" append-to-body
      @closed="onApprovalRecordDialogClosed">
      <template slot="title">
        <span>审批记录</span>
        <span v-if="approvalRecordRow.id" class="review-title-sub">（订单号：{{ approvalRecordRow.id }}）</span>
      </template>
      <div v-loading="approvalRecordLoading" class="approval-record-body">
        <div class="approval-record-dw-section">
          <div class="review-dw-section-title">充提记录</div>
          <div v-loading="approvalRecordTxSummaryLoading" class="review-dw-panel">
            <el-row :gutter="16" type="flex" align="middle">
              <el-col :span="7">
                <div class="review-dw-stat-label">总充值（折合 USDT）</div>
                <div class="review-dw-stat-value">
                  {{ formatReviewUsdt(approvalRecordTxSummary.totalDepositUsdt) }}
                </div>
              </el-col>
              <el-col :span="7">
                <div class="review-dw-stat-label">总提现（折合 USDT）</div>
                <div class="review-dw-stat-value">
                  {{ formatReviewUsdt(approvalRecordTxSummary.totalWithdrawUsdt) }}
                </div>
              </el-col>
              <el-col :span="10">
                <el-date-picker v-model="approvalRecordTxTimeRange" type="datetimerange" range-separator="至"
                  start-placeholder="开始时间" end-placeholder="结束时间" value-format="timestamp" style="width: 100%"
                  @change="onApprovalRecordTxTimeRangeChange" />
              </el-col>
            </el-row>
            <div class="review-dw-expand-row">
              <el-button type="text" :icon="approvalRecordTxDetailExpanded
                ? 'el-icon-minus'
                : 'el-icon-plus'
                " @click="toggleApprovalRecordTxDetail" />
            </div>
            <div v-show="approvalRecordTxDetailExpanded" class="review-dw-detail">
              <el-table v-loading="approvalRecordTxDetailLoading" :data="approvalRecordTxDetailList" size="small" border
                max-height="280">
                <el-table-column prop="txTypeName" label="类型" width="72" />

                <el-table-column prop="txCoin" label="币种" width="88" />
                <el-table-column prop="txAmount" label="数量" min-width="100" />
                <el-table-column label="时间" min-width="152">
                  <template slot-scope="scope">{{
                    scope.row.createdTime | moment }}</template>
                </el-table-column>
                <el-table-column prop="id" label="订单号" min-width="120" show-overflow-tooltip />
              </el-table>
              <el-pagination small layout="prev, pager, next" :page-size="approvalRecordTxDetailSize"
                :current-page="approvalRecordTxDetailPage" :total="approvalRecordTxDetailTotal"
                @current-change="onApprovalRecordTxDetailPageChange" />
            </div>
          </div>
        </div>
        <div class="review-dw-section-title">审批流水</div>
        <el-table :data="approvalRecordList" size="small" border max-height="360">
          <el-table-column prop="operatorDisplayName" label="审批人" min-width="120">
          </el-table-column>
          <el-table-column prop="approvalStatusName" label="审批状态" min-width="120">
          </el-table-column>
          <el-table-column label="审批时间" min-width="160">
            <template slot-scope="scope">{{
              scope.row.updateTime | moment
            }}</template>
          </el-table-column>
          <el-table-column prop="remark" label="审批意见" min-width="160" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approvalRecordVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import WithdrawRecords from "../records";
import Pagination from "components/pagination";

export default {
  name: "AuditList",
  props: ["activeTab"],
  data() {
    return {
      blockId: "",
      title: "",
      title1: "",
      retryId: "",
      form: {},
      retryForm: {},
      dialogVisible: false,
      retryDialogVisible: false,
      showUserDialog: false,
      ifShowSendDialog: false,
      blockDialogVisible: false,
      nowUserId: "",
      emails: "",
      sendOrderId: "",
      detail: {},
      blockForm: {},
      sendTransForm: {
        id: "",
      },
      multipleSelection: "",
      retryableStatus: [
        "FAIL_CANNOT_RETRY",
        "EXECUTING_WITHDRAW",
        "HOT_NOT_ENOUGH_MONEY",
        "DUPLICATE_TO_ADDRESS",
      ],
      WITHDRAW_REVIEW_GOOGLE_EXPIRED_CODE: 9401,
      googleReviewVisible: false,
      reviewDialogVisible: false,
      reviewRow: {},
      reviewForm: {
        remark: "",
        decision: "APPROVE",
      },
      googleReviewForm: {
        googleCode: "",
      },
      approvalTimeline: [],
      reviewTxTimeRange: null,
      reviewTxSummary: {
        totalDepositUsdt: null,
        totalWithdrawUsdt: null,
      },
      reviewTxSummaryLoading: false,
      reviewTxDetailExpanded: false,
      reviewTxDetailList: [],
      reviewTxDetailTotal: 0,
      reviewTxDetailPage: 1,
      reviewTxDetailSize: 10,
      reviewTxDetailLoading: false,
      approvalRecordVisible: false,
      approvalRecordLoading: false,
      approvalRecordList: [],
      approvalRecordRow: {},
      approvalRecordTxTimeRange: null,
      approvalRecordTxSummary: {
        totalDepositUsdt: null,
        totalWithdrawUsdt: null,
      },
      approvalRecordTxSummaryLoading: false,
      approvalRecordTxDetailExpanded: false,
      approvalRecordTxDetailList: [],
      approvalRecordTxDetailTotal: 0,
      approvalRecordTxDetailPage: 1,
      approvalRecordTxDetailSize: 10,
      approvalRecordTxDetailLoading: false,
      googleReviewRules: {
        googleCode: [
          { required: true, message: "请填写谷歌验证码", trigger: "blur" },
        ],
      },
      /** 关闭谷歌弹窗时若为 ensure 链路，回调 true/false */
      _pendingGoogleSessionContinuation: null,
      rules: {
        txHash: [{ required: true, message: "请输入TxHash", trigger: blur }],
        gasLimit: [
          { required: true, message: "请填写gasLimit", trigger: blur },
        ],
        gasPrice: [
          { required: true, message: "请填写gasPrice", trigger: blur },
        ],
      },
    };
  },
  computed: {
    ...mapState("withdrawalAudit", [
      "auditList",
      "allCoins",
      "audistCount",
      "pagination",
    ]),
    ...mapState(["userInfo"]),
    showApprovalRecordButton() {
      const tabs = ["4", "5", "0", "-1", "2", "6", "7"];
      return tabs.includes(String(this.activeTab));
    },
    reviewRules() {
      return {
        decision: [
          { required: true, message: "请选择审批结果", trigger: "change" },
        ],
        remark: [
          {
            validator: (rule, value, callback) => {
              const d = this.reviewForm.decision;
              if (
                (d === "REJECT" || d === "ABNORMAL") &&
                (!value || !String(value).trim())
              ) {
                callback(new Error(" "));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions("withdrawalAudit", [
      "approve",
      "retry",
      "resetUserRecords",
      "setAuditToErr",
      "cancel",
      "updateFreeze",
      "sendWithdrawalTrans",
      "remark",
      "manualConfirm",
      "returnToNotApproved",
      "sentConfirmed",
      "checkWithdrawGoogleSession",
      "verifyWithdrawReviewGoogle",
      "getWithdrawApprovalTimeline",
      "submitWithdrawReview",
      "fetchWithdrawReviewTxBounds",
      "fetchWithdrawReviewTxSummary",
      "fetchWithdrawReviewTxPage",
    ]),
    ensureWithdrawGoogleSession() {
      return this.checkWithdrawGoogleSession().then((res) => {
        if (res && res.code === 0 && res.data === true) {
          return true;
        }
        this.googleReviewForm = { googleCode: "" };
        this.googleReviewVisible = true;
        this.$nextTick(() => {
          if (this.$refs.googleReviewForm) {
            this.$refs.googleReviewForm.clearValidate();
          }
        });
        return new Promise((resolve) => {
          this._pendingGoogleSessionContinuation = resolve;
        });
      });
    },
    /**
     * 会话过期（9401）时先走谷歌弹窗，通过后重试同一请求一次
     */
    withGoogleSessionRetry(requestFn) {
      const run = () => requestFn();
      return run().then((res) => {
        if (res && res.code === this.WITHDRAW_REVIEW_GOOGLE_EXPIRED_CODE) {
          return this.ensureWithdrawGoogleSession().then((ok) => {
            if (!ok) return res;
            return run();
          });
        }
        return res;
      });
    },
    handleGoogleReviewBeforeClose(done) {
      if (this._pendingGoogleSessionContinuation) {
        const cont = this._pendingGoogleSessionContinuation;
        this._pendingGoogleSessionContinuation = null;
        cont(false);
      }
      done();
    },
    closeGoogleReviewDialog() {
      if (this._pendingGoogleSessionContinuation) {
        const cont = this._pendingGoogleSessionContinuation;
        this._pendingGoogleSessionContinuation = null;
        cont(false);
      }
      this.googleReviewVisible = false;
    },
    withdrawListRowClassName({ row }) {
      return row.mark ? "withdraw-list-row-risk" : "";
    },
    clearAuditSelection() {
      const t = this.$refs.auditTable;
      if (t) {
        t.clearSelection();
      }
      this.multipleSelection = "";
      this.$store.commit("withdrawalAudit/setIdStr", "");
      this.$store.commit("withdrawalAudit/setSelectedWithdrawRows", []);
    },
    canRetry(txStatus) {
      if (txStatus === 4) {
        return this.$hasPerm("tenant:audit_withdrawal:tab_4_retry");
      }
      if (txStatus === 5) {
        return this.$hasPerm("tenant:audit_withdrawal:tab_5_retry");
      }
      return false;
    },
    canMarkAbnormal(txStatus) {
      if (txStatus === 1) {
        return this.$hasPerm("tenant:audit_withdrawal:tab_1_mark_abnormal");
      }
      if (txStatus === 4) {
        return this.$hasPerm("tenant:audit_withdrawal:tab_4_mark_abnormal");
      }
      return false;
    },
    onReviewDecisionChange() {
      this.$nextTick(() => {
        if (this.$refs.reviewFormRef) {
          this.$refs.reviewFormRef.clearValidate("remark");
        }
      });
    },
    onReviewDialogClosed() {
      this.reviewRow = {};
      this.approvalTimeline = [];
      this.reviewTxTimeRange = null;
      this.reviewTxSummary = {
        totalDepositUsdt: null,
        totalWithdrawUsdt: null,
      };
      this.reviewTxDetailExpanded = false;
      this.reviewTxDetailList = [];
      this.reviewTxDetailTotal = 0;
      this.reviewTxDetailPage = 1;
    },
    formatReviewUsdt(val) {
      if (val === null || val === undefined || val === "") {
        return "—";
      }
      const n = Number(val);
      if (Number.isNaN(n)) {
        return "—";
      }
      return n.toLocaleString(undefined, { maximumFractionDigits: 8 });
    },
    initReviewTxPanel() {
      const uid = this.reviewRow.userId;
      if (!uid) {
        return Promise.resolve();
      }
      return this.fetchWithdrawReviewTxBounds({ tenantUserId: String(uid) })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            const { firstSuccessTime, lastSuccessTime } = res.data;
            if (firstSuccessTime != null && lastSuccessTime != null) {
              this.reviewTxTimeRange = [firstSuccessTime, lastSuccessTime];
            }
          }
        })
        .catch(() => { })
        .then(() => this.reloadReviewTxSummary());
    },
    reloadReviewTxSummary() {
      const uid = this.reviewRow.userId;
      if (!uid) {
        return Promise.resolve();
      }
      let startTime = null;
      let endTime = null;
      if (
        Array.isArray(this.reviewTxTimeRange) &&
        this.reviewTxTimeRange.length === 2
      ) {
        startTime = this.reviewTxTimeRange[0];
        endTime = this.reviewTxTimeRange[1];
      }
      this.reviewTxSummaryLoading = true;
      return this.fetchWithdrawReviewTxSummary({
        tenantUserId: String(uid),
        startTime,
        endTime,
      })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.reviewTxSummary = res.data;
          } else {
            this.reviewTxSummary = {
              totalDepositUsdt: 0,
              totalWithdrawUsdt: 0,
            };
          }
        })
        .finally(() => {
          this.reviewTxSummaryLoading = false;
        });
    },
    onReviewTxTimeRangeChange() {
      this.reloadReviewTxSummary();
      if (this.reviewTxDetailExpanded) {
        this.reviewTxDetailPage = 1;
        this.loadReviewTxDetailPage();
      }
    },
    toggleReviewTxDetail() {
      this.reviewTxDetailExpanded = !this.reviewTxDetailExpanded;
      if (this.reviewTxDetailExpanded) {
        this.reviewTxDetailPage = 1;
        this.loadReviewTxDetailPage();
      }
    },
    loadReviewTxDetailPage() {
      const uid = this.reviewRow.userId;
      if (!uid) {
        return;
      }
      let startTime = null;
      let endTime = null;
      if (
        Array.isArray(this.reviewTxTimeRange) &&
        this.reviewTxTimeRange.length === 2
      ) {
        startTime = this.reviewTxTimeRange[0];
        endTime = this.reviewTxTimeRange[1];
      }
      this.reviewTxDetailLoading = true;
      this.fetchWithdrawReviewTxPage({
        tenantUserId: String(uid),
        startTime,
        endTime,
        page: this.reviewTxDetailPage,
        size: this.reviewTxDetailSize,
      })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.reviewTxDetailList = res.data.list || [];
            this.reviewTxDetailTotal = res.data.totalCount || 0;
          } else {
            this.reviewTxDetailList = [];
            this.reviewTxDetailTotal = 0;
          }
        })
        .finally(() => {
          this.reviewTxDetailLoading = false;
        });
    },
    onReviewTxDetailPageChange(p) {
      this.reviewTxDetailPage = p;
      this.loadReviewTxDetailPage();
    },
    initApprovalRecordTxPanel() {
      const uid = this.approvalRecordRow.userId;
      if (!uid) {
        return Promise.resolve();
      }
      return this.fetchWithdrawReviewTxBounds({ tenantUserId: String(uid) })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            const { firstSuccessTime, lastSuccessTime } = res.data;
            if (firstSuccessTime != null && lastSuccessTime != null) {
              this.approvalRecordTxTimeRange = [
                firstSuccessTime,
                lastSuccessTime,
              ];
            }
          }
        })
        .catch(() => { })
        .then(() => this.reloadApprovalRecordTxSummary());
    },
    reloadApprovalRecordTxSummary() {
      const uid = this.approvalRecordRow.userId;
      if (!uid) {
        return Promise.resolve();
      }
      let startTime = null;
      let endTime = null;
      if (
        Array.isArray(this.approvalRecordTxTimeRange) &&
        this.approvalRecordTxTimeRange.length === 2
      ) {
        startTime = this.approvalRecordTxTimeRange[0];
        endTime = this.approvalRecordTxTimeRange[1];
      }
      this.approvalRecordTxSummaryLoading = true;
      return this.fetchWithdrawReviewTxSummary({
        tenantUserId: String(uid),
        startTime,
        endTime,
      })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.approvalRecordTxSummary = res.data;
          } else {
            this.approvalRecordTxSummary = {
              totalDepositUsdt: 0,
              totalWithdrawUsdt: 0,
            };
          }
        })
        .finally(() => {
          this.approvalRecordTxSummaryLoading = false;
        });
    },
    onApprovalRecordTxTimeRangeChange() {
      this.reloadApprovalRecordTxSummary();
      if (this.approvalRecordTxDetailExpanded) {
        this.approvalRecordTxDetailPage = 1;
        this.loadApprovalRecordTxDetailPage();
      }
    },
    toggleApprovalRecordTxDetail() {
      this.approvalRecordTxDetailExpanded = !this.approvalRecordTxDetailExpanded;
      if (this.approvalRecordTxDetailExpanded) {
        this.approvalRecordTxDetailPage = 1;
        this.loadApprovalRecordTxDetailPage();
      }
    },
    loadApprovalRecordTxDetailPage() {
      const uid = this.approvalRecordRow.userId;
      if (!uid) {
        return;
      }
      let startTime = null;
      let endTime = null;
      if (
        Array.isArray(this.approvalRecordTxTimeRange) &&
        this.approvalRecordTxTimeRange.length === 2
      ) {
        startTime = this.approvalRecordTxTimeRange[0];
        endTime = this.approvalRecordTxTimeRange[1];
      }
      this.approvalRecordTxDetailLoading = true;
      this.fetchWithdrawReviewTxPage({
        tenantUserId: String(uid),
        startTime,
        endTime,
        page: this.approvalRecordTxDetailPage,
        size: this.approvalRecordTxDetailSize,
      })
        .then((res) => {
          if (res && res.code === 0 && res.data) {
            this.approvalRecordTxDetailList = res.data.list || [];
            this.approvalRecordTxDetailTotal = res.data.totalCount || 0;
          } else {
            this.approvalRecordTxDetailList = [];
            this.approvalRecordTxDetailTotal = 0;
          }
        })
        .finally(() => {
          this.approvalRecordTxDetailLoading = false;
        });
    },
    onApprovalRecordTxDetailPageChange(p) {
      this.approvalRecordTxDetailPage = p;
      this.loadApprovalRecordTxDetailPage();
    },
    onApprovalRecordDialogClosed() {
      this.approvalRecordRow = {};
      this.approvalRecordList = [];
      this.approvalRecordTxTimeRange = null;
      this.approvalRecordTxSummary = {
        totalDepositUsdt: null,
        totalWithdrawUsdt: null,
      };
      this.approvalRecordTxDetailExpanded = false;
      this.approvalRecordTxDetailList = [];
      this.approvalRecordTxDetailTotal = 0;
      this.approvalRecordTxDetailPage = 1;
    },
    openApprovalRecordDialog(row) {
      this.approvalRecordRow = { ...row };
      this.approvalRecordTxTimeRange = null;
      this.approvalRecordTxDetailExpanded = false;
      this.approvalRecordTxDetailList = [];
      this.approvalRecordTxDetailTotal = 0;
      this.approvalRecordTxDetailPage = 1;
      this.approvalRecordVisible = true;
      this.approvalRecordLoading = true;
      this.approvalRecordList = [];
      Promise.all([
        this.getWithdrawApprovalTimeline(row.id),
        this.initApprovalRecordTxPanel(),
      ])
        .then(([tlRes]) => {
          this.approvalRecordLoading = false;
          if (tlRes && tlRes.code === 0) {
            this.approvalRecordList = tlRes.data || [];
          } else {
            this.approvalRecordList = [];
          }
        })
        .catch(() => {
          this.approvalRecordLoading = false;
          this.approvalRecordList = [];
        });
    },
    startWithdrawReview(row) {
      this.reviewRow = { ...row };
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (ok) this.openWithdrawReviewDialog();
      });
    },
    openWithdrawReviewDialog() {
      this.reviewForm = { remark: "", decision: "APPROVE" };
      this.reviewTxTimeRange = null;
      this.reviewTxDetailExpanded = false;
      this.reviewTxDetailList = [];
      this.reviewTxDetailTotal = 0;
      this.reviewTxDetailPage = 1;
      Promise.all([
        this.getWithdrawApprovalTimeline(this.reviewRow.id),
        this.initReviewTxPanel(),
      ]).then(([tlRes]) => {
        if (tlRes && tlRes.code === 0) {
          this.approvalTimeline = tlRes.data || [];
        } else {
          this.approvalTimeline = [];
        }
        this.reviewDialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.reviewFormRef) {
            this.$refs.reviewFormRef.clearValidate();
          }
        });
      });
    },
    confirmGoogleReview() {
      this.$refs.googleReviewForm.validate((valid) => {
        if (!valid) return;
        this.verifyWithdrawReviewGoogle(this.googleReviewForm.googleCode).then(
          (res) => {
            if (res && res.code === 0) {
              this.googleReviewVisible = false;
              this.googleReviewForm = { googleCode: "" };
              const cont = this._pendingGoogleSessionContinuation;
              this._pendingGoogleSessionContinuation = null;
              if (cont) {
                cont(true);
              } else {
                this.openWithdrawReviewDialog();
              }
            }
          }
        );
      });
    },
    confirmWithdrawReviewSubmit() {
      this.$refs.reviewFormRef.validate((valid) => {
        if (!valid) return;
        this.withGoogleSessionRetry(() =>
          this.submitWithdrawReview({
            id: this.reviewRow.id,
            decision: this.reviewForm.decision,
            remark: this.reviewForm.remark,
          })
        ).then((res) => {
          if (res && res.code === 0) {
            this.reviewDialogVisible = false;
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.refreshList();
          }
        });
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    showPrompt(content, callback) {
      return this.$prompt(content, "提示", {
        inputPlaceholder: "操作意见",
        inputValue: "",
        beforeClose: (action, instance, done) => {
          if (instance.confirmButtonLoading) return;
          if (action !== "confirm") {
            done();
            return;
          }
          instance.confirmButtonLoading = true;
          Promise.resolve()
            .then(() => callback((instance.inputValue || "").trim()))
            .then((res) => {
              if (res && res.code === 0) {
                // Element UI 会先记录取消动作；请求期间的取消不能覆盖成功结果。
                instance.action = "confirm";
                done();
              } else {
                this.$message.error((res && res.msg) || "操作未完成，请重试");
              }
            })
            .catch((error) => {
              this.$message.error((error && error.message) || "操作失败，请重试");
            })
            .finally(() => {
              instance.confirmButtonLoading = false;
            });
        },
      }).then(() => {
        this.$message({ message: "操作成功！", type: "success" });
        this.refreshList();
      }).catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id).join();
      this.$store.commit("withdrawalAudit/setIdStr", this.multipleSelection);
      this.$store.commit("withdrawalAudit/setSelectedWithdrawRows", val);
    },
    submit() {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.withGoogleSessionRetry(() =>
              this.approve({
                id: this.detail.id,
              })
            ).then((res) => {
              if (res.code == 0) {
                this.dialogVisible = false;
                this.form = {};
                this.$message({
                  message: "操作成功！",
                  type: "success",
                });
                this.refreshList();
                this.$refs.form.resetFields();
              }
            });
          }
        });
      });
    },
    retrySubmit() {
      this.$refs.retryForm.validate((valid) => {
        if (valid) {
          this.withGoogleSessionRetry(() =>
            this.retry({
              id: this.retryId,
              gasLimit: this.retryForm.gasLimit,
              gasPrice: this.retryForm.gasPrice,
            })
          ).then((res) => {
            if (res.code == 0) {
              this.retryDialogVisible = false;
              this.retryForm = {};
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.refreshList();
              this.$refs.retryForm.resetFields();
            }
          });
        }
      });
    },
    freezeAudit(audit) {
      return this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        return this.showPrompt("确认要置为异常吗？", (remark) =>
          this.withGoogleSessionRetry(() => this.updateFreeze({ id: audit.id, remark }))
        );
      });
    },
    cancelAudit(audit) {
      return this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        return this.showPrompt("确认要撤销吗？", (remark) =>
          this.withGoogleSessionRetry(() => this.cancel({ id: audit.id, remark }))
        );
      });
    },
    retryWithdrawal(audit) {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.retryId = audit.id;
        this.retryDialogVisible = true;
        this.title1 =
          "重试前，请确认该提现地址在区块链浏览器上没有此平台的转账记录。";
      });
    },
    setAuditError(audit) {
      return this.freezeAudit(audit);
    },
    getUserDetail(uid, email) {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.nowUserId = uid;
        this.emails = email;
        this.showUserDialog = true;
      });
    },
    refreshList() {
      this.handleCurrentChange({
        page: 1,
      });
    },
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
    showSendDialog(id) {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.sendOrderId = id;
        this.ifShowSendDialog = true;
      });
    },
    sendTransNow() {
      this.$refs["sendTransForm"].validate((valid) => {
        if (valid) {
          this.withGoogleSessionRetry(() =>
            this.sendWithdrawalTrans({
              id: this.sendOrderId,
              transId: this.sendTransForm.transId,
            })
          ).then((res) => {
            if (res && res.code === 0) {
              this.closeSendDialog();
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.refreshList();
            }
          });
        }
      });
    },
    closeSendDialog() {
      this.$refs["sendTransForm"] && this.$refs["sendTransForm"].resetFields();
      this.ifShowSendDialog = false;
    },
    handleManualConfirm(txId) {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.$confirm("确认手动转账已成功吗？", "提示", {
          type: "warning",
        }).then(() => {
          this.withGoogleSessionRetry(() => this.manualConfirm(txId)).then(
            (res) => {
              if (res && res.code === 0) {
                this.$message.success("操作成功！");
                this.refreshList();
              }
            }
          );
        });
      });
    },
    handleReturnToNotApproved(txId) {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.$confirm("确认退回未审核状态吗？", "提示", {
          type: "warning",
        }).then(() => {
          this.withGoogleSessionRetry(() =>
            this.returnToNotApproved(txId)
          ).then((res) => {
            if (res && res.code === 0) {
              this.$message.success("操作成功！");
              this.refreshList();
            }
          });
        });
      });
    },
    blockSubmit() {
      console.log("audit", this.blockId);
      this.$refs.blockForm.validate((valid) => {
        if (valid) {
          this.withGoogleSessionRetry(() =>
            this.sentConfirmed({
              id: this.blockId,
              txHash: this.blockForm.txHash,
            })
          ).then((res) => {
            if (res.code == 0) {
              this.blockDialogVisible = false;
              this.$message.success("操作成功！");
              this.refreshList();
              this.$refs.blockForm.resetFields();
            }
          });
        }
      });
    },
    handleSentConfirmed(audit) {
      this.ensureWithdrawGoogleSession().then((ok) => {
        if (!ok) return;
        this.blockId = audit.id;
        this.blockDialogVisible = true;
      });
    },
  },
  components: {
    WithdrawRecords,
    Pagination,
  },
};
</script>

<style lang="less" scoped>
@import url("~styles/variables.less");

.account-link,
.network-link {
  color: @color-primary;

  &:hover {
    text-decoration: underline;
  }
}

.red {
  color: red;
  font-weight: bold;
}

.review-title-sub {
  color: #909399;
  font-weight: normal;
  font-size: 14px;
  margin-left: 4px;
}

.review-dw-panel {
  width: 100%;
}

.review-dw-stat-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.review-dw-stat-value {
  font-size: 14px;
  font-weight: 500;
}

.review-dw-expand-row {
  margin-top: 8px;
}

.review-dw-detail {
  margin-top: 8px;
}

.review-dw-detail .el-pagination {
  margin-top: 8px;
  text-align: right;
}

.approval-record-body {
  min-height: 80px;
}

.review-dw-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 12px 0 8px;
}

.approval-record-dw-section .review-dw-section-title {
  margin-top: 0;
}

.review-risk-banner {
  text-align: center;
  color: #f56c6c;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 12px;
}

::v-deep .el-table tbody tr.withdraw-list-row-risk>td {
  background-color: #fef0f0 !important;
}
</style>
